import * as Yup from "yup";

export const captions = [
  "Sr.NO",
  "Location Name",
  "Plotting Code",
  "Plotting Name",
  "Total Plotting Area (Hect.)",
  "Total Number of Planting",
  "Action",
];

export const formInitialValues = {
  Plant_Scientific_Name: "",
  Plant_Eng_Name: "",
  Plant_Local_Name: "",
  Plant_Habit: "",
  Plant_Nature: "",
  Plantation_Type: "",
  Type_Of_Soil: "demo",
  Monitoring_Frequency: "",
  Plant_Desc: "",
  Plant_Img: null,
  Plant_Uses: "",
  Plant_Season: "",
  Is_Active: false,
};
const charRegex = /^(?=.*[a-zA-Z_])[a-zA-Z0-9_\s]+$/;

export const formValidationSchema = Yup.object().shape({
  Plant_Scientific_Name: Yup.string()
    .trim()
    .required("Plant Scientific name is required")
    .max(100)
    .matches(
      charRegex,
      "Plant Scientific name must contain at least one letter and can include numbers and spaces"
    ),
  Plant_Eng_Name: Yup.string()
    .trim()
    .required("Plant English name is required")
    .max(100)
    .matches(
      charRegex,
      "Plant English name must contain at least one letter and can include numbers and spaces"
    ),
  Plant_Local_Name: Yup.string()
    .trim()
    .required("Plant Local name is required")
    .max(100)
    .matches(
      charRegex,
      "Plant Local name must contain at least one letter and can include numbers and spaces"
    ),
  Plant_Habit: Yup.string().trim().required("Plant habit is required").max(100),
  Plant_Nature: Yup.string()
    .trim()
    .required("Plant nature is required")
    .max(100),
  Plantation_Type: Yup.string()
    .trim()
    .required("Plantation type is required")
    .max(100),
  Type_Of_Soil: Yup.string()
    .trim()
    .required("Plant Soil type is required")
    .max(100),
  Monitoring_Frequency: Yup.string()
    .trim()
    .required("Plant Monitoring frequency is required"),
  Plant_Desc: Yup.string().trim().max(250),
  // Plant_Color: Yup.string().trim().required("Plant color is required").max(100),
  Plant_Uses: Yup.string().trim().required("Plant uses are required").max(255),
  Plant_Season: Yup.string()
    .trim()
    .required("Plant season is required")
    .max(100),
  Is_Active: Yup.boolean(),
  Plant_Img: Yup.mixed()
    .nullable()
    .test("FILE_SIZE", "Please upload file upto 2mb.", (value) => {
      if (typeof value === "string") return true;
      if (value) {
        if (value.size > 2000000) {
          return false;
        }
      }
      return true;
    })
    .test(
      "fileFormat",
      "Please upload file in jpg/png/jpeg format only.",
      (value) => {
        if (typeof value === "string") return true;
        if (value) {
          if (!["image/png", "image/jpeg", "image/jpg"].includes(value.type)) {
            return false;
          }
        }
        return true;
      }
    ),
});

export const MAX_CHARACTER_LENGTH = 250;
